import { render, staticRenderFns } from "./guestsInStock.vue?vue&type=template&id=1a3b8c24"
import script from "./guestsInStock.vue?vue&type=script&lang=ts"
export * from "./guestsInStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports